module.exports = __webpack_public_path__ + "1d94662c7787275086bc9e7b72d469cb.png";